import { apiClient } from '@/shared/api/apiClient';
import { handleRequest } from '@/shared/api/apiWrapper';
import type {
  SbpOperationDirection,
  SbpPaymentTypeResponse,
} from '@/shared/types';
import { objectToQueryParamsStr } from '@/shared/utils';

export const getSbpPaymentType = async (
  direction: SbpOperationDirection,
  currencyCode: string
): Promise<SbpPaymentTypeResponse> => {
  const request = () =>
    apiClient.get<SbpPaymentTypeResponse>(
      `/operations/sbp/${direction}/paymentType?${objectToQueryParamsStr({ currencyCode })}`
    );
  const response = await handleRequest<SbpPaymentTypeResponse>(request);

  return response.data;
};
